import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ActionMenu from './ActionMenu';
import ActionSection from './ActionSection';
import ActionButtonMenu from './ActionButtonMenu';
import TooltipEnclosure from '../../../../../components/TooltipEnclosure';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
  },
}));

const CellAction = ({ row = {} }) => {
  const classes = useStyles();
  const [actionMenu, setActionMenu] = useState(null);
  const { original = {} } = row;

  const handleClickActionMenu = (event) => {
    setActionMenu(event.currentTarget);
  };

  const handleCloseActionMenu = () => {
    setActionMenu(null);
  };

  return (
    <div className={classes.root}>
      <ActionSection original={original} />
      <TooltipEnclosure
        title="Duplicate, rename, delete"
        className="button-holder"
      >
        <ActionButtonMenu onClick={handleClickActionMenu} />
      </TooltipEnclosure>

      <ActionMenu
        actionMenu={actionMenu}
        original={original}
        onClose={handleCloseActionMenu}
      />
    </div>
  );
};

export default CellAction;
